










import Vue from 'vue'
import { mapState, mapGetters } from 'vuex'
import SurfaceOffline from 'vuecomponents/surface_offline.vue'
import SurfaceContainer from 'vuecomponents/surface_container.vue'
import AppGlobalSnackbar from 'vuecomponents/app_global_snackbar.vue'
import NativeAppMixin from 'vuemixins/native_app_mixin'
import GlobalStylesMixin from 'vuemixins/global_styles_mixin'
import PageStylingMixin from 'vuemixins/page_styling_mixin'
import FullscreenMixin from 'vuemixins/fullscreen_mixin'
import WindowSizeMixin from 'vuemixins/window_size_mixin'
import PresenceMixin from 'vuemixins/presence_mixin'
import device from 'bits/device'

const mixins: any[] = [GlobalStylesMixin, PageStylingMixin, FullscreenMixin, WindowSizeMixin, PresenceMixin]
if (device.app) {
  mixins.push(NativeAppMixin)
}

export default Vue.extend({
  components: {
    SurfaceOffline,
    SurfaceContainer,
    AppGlobalSnackbar,
    SurfaceAddPost: () => import('vuecomponents/surface_add_post.vue'),
    SurfacePanels: () => import('vuecomponents/surface_panels.vue'),
  },
  mixins,
  computed: {
    ...mapState(['isOnline']),
    ...mapGetters('snackbars', ['xSnackbar']),
  },
})
